import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=8967c2ea&scoped=true"
import script from "./PermissionTree.vue?vue&type=script&lang=js"
export * from "./PermissionTree.vue?vue&type=script&lang=js"
import style0 from "./PermissionTree.vue?vue&type=style&index=0&id=8967c2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8967c2ea",
  null
  
)

export default component.exports